module.exports = __webpack_public_path__ + "static/media/la-nacion.8fb4e23e.svg";